export function scribeAuthCookie(): string {
  const sessionCookies = document.cookie
    .split(';')
    .map((val) => val.trim())
    .filter((val) => val.startsWith('session'));

  if (sessionCookies.length > 0) {
    return sessionCookies[0].split('=')[1];
  }
  return '';
}
